export type NavVariant = 'default' | 'blue'

export interface NavRouteConfig {
  variant: NavVariant
  transparent: boolean
}

const TRANSPARENT_ROUTES: Record<string, NavRouteConfig> = {
  '/': { variant: 'default', transparent: true },
  '/articles': { variant: 'blue', transparent: true },
  '/resources': { variant: 'default', transparent: true },
  '/about': { variant: 'blue', transparent: true },
}

export function normalizePathname(pathname: string | null | undefined): string {
  if (!pathname || pathname === '/') return '/'
  return pathname.replace(/\/+$/, '').toLowerCase() || '/'
}

export function getNavRouteConfig(pathname: string | null | undefined): NavRouteConfig {
  const normalized = normalizePathname(pathname)
  return TRANSPARENT_ROUTES[normalized] ?? { variant: 'default', transparent: false }
}
